import fundsReducer from '../state/funds-slice'

export const backOfficeReducers = {
  funds: fundsReducer
}
